export default __webpack_public_path__ + "static/media/arcade_stock.d142999a.jpeg";